/** @format */

export const HOME_CONSTANTS: any = {
	appPathPrefix: 'home',
	ggStaticColors: {
		primary: '#00203a',
		secondary: '#191f1c'
	}
};
